// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowButton-module--arrow--hZrnr","next":"ArrowButton-module--next--1e_at","prev":"ArrowButton-module--prev--1y66g"};